import {useFusionAuth} from "@fusionauth/react-sdk";
import React from 'react';
import {useDispatch} from 'react-redux';
import * as authRoutines from "../Containers/Auth/authRoutines";
import CircularProgress from "@material-ui/core/CircularProgress";
const AuthCallback  = (props:any) =>{
    const { login, isAuthenticated } = useFusionAuth();

    const dispatch = useDispatch();
    React.useEffect( () => {
        if(isAuthenticated) {
           dispatch(authRoutines.commandCenterLogin());
        }else{
            login()
        }
    },[isAuthenticated])

    return <CircularProgress/>
}
export default  AuthCallback;